import { ModalContent, ModalFooter } from '@src/app-components/secondary-modal';
import UserCard from '@src/app-components/user-card/UserCard';
import { useModal } from '@src/stores';
import { Alert } from '@trussworks/react-uswds';

const TransferOwnershipModal = ({ user, onConfirm = () => {}, onCancel = () => {} }) => {
  const { closeSecondaryModal } = useModal();

  const handleTransferOwnership = () => {
    onConfirm(user);
    closeSecondaryModal();
  };

  const handleCancel = () => {
    onCancel();
    closeSecondaryModal();
  };

  return (
    <ModalContent title='Are you sure you want to transfer project ownership?' size='small'>
      <section className='modal-body'>
        <div className='label-value'>
          <b>New Project Owner:</b>
        </div>
        <div className='user-card-container'>
          <div className='margin-bottom-1'>
            <UserCard user={user} showSelectRole={false} />
          </div>
        </div>
        <Alert type='warning' slim>
          Your access to all requests within this project will change to <span className='text-bold'>READ-ONLY</span>{' '}
          and you will no longer be able to manage access for this project or its requests.
        </Alert>
      </section>
      <ModalFooter saveText='Confirm' onSave={handleTransferOwnership} showCancelButton onCancel={handleCancel} />
    </ModalContent>
  );
};

export default TransferOwnershipModal;
